// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3833":"0602af56","6977":"e96aa775","7301":"4bfff6e4","7594":"0602af56"}[chunkId] + ".chunk.css";
};